import React, { useEffect } from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { Card, Flex, Hide, Text, BlockLink } from 'pcln-design-system'
import { WebPBackgroundImage } from '@pcln/content-tile'
import * as PCLNAnalytics from '../../../utils/PCLN-Analytics'

const Wrapper = styled(Card)`
  height: 340px;
  ${props => props.theme.mediaQueries[3]} {
    height: 250px;
  }
  background-color: white;
  border-radius: 4px;
`
const PromoBoxLink = styled(BlockLink)`
  height: 100%;
  &:hover{
    text-decoration: none !important;
    color: inherit;
    overflow: visible;
    box-shadow: rgba(0, 0, 0, 0.08) 0px 0px 6px 0px, rgba(0, 0, 0, 0.16) 0px 4px 16px 0px;
    border-width: 1px;
    border-color: rgb(192, 202, 213);
    border-image: initial;
    border-radius: 3px;
  }
`
const FlexWithTopBorder = styled(Flex)`
  border-top: 6px solid ${props => props.borderTopColor || props.theme.colors.blue};
  height: 100%;
  border-radius: 3px;
`
const Headline = styled(Text)`
  font-size: ${props => props.fontSize || '32px'};
  line-height: 36px;
`
const SubHeadLine = styled(Text)`
  font-size: ${props => props.fontSize || '14px'};
  color: ${props => props.color || props.theme.colors.black};
`
const ImageOnRightWebP = styled(WebPBackgroundImage)`
  align-self: flex-start;
  height: 100%;
  object-fit: cover;
  object-position: -40px;
  position: relative;
  border-bottom-right-radius: 3px;
  right: 0;
  background-color: #fff;
`
const ImageOnTopWebP = styled(WebPBackgroundImage)`
  width: 100%;
  flex-shrink: 0;
  object-fit: cover;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
  background-color: #fff;
`
const TextWrapper = styled(Flex)`
  height: 210px;
  width: 100%;
  ${props => props.theme.mediaQueries[3]} {
    height: 240px;
  }
`

const trackKaleyAdBoxEvents = (analytics = {}, action) => {
  const analyticsData = { ...analytics, action: `${analytics.action} ${action}` }
  PCLNAnalytics.send({
    ...analyticsData
  })
}

const KaleyPromoAdBox = (props) => {
  const {
    headline1,
    headline1Color,
    headline1FontSize,
    headline2,
    headline2Color,
    headline2FontSize,
    subHeadline,
    subHeadlineColor,
    subHeadlineFontSize,
    moreInfoText,
    boxLink,
    borderTopColor,
    desktopImageJPGUrl,
    desktopImageWEBPUrl,
    tabletImageJPGUrl,
    tabletImageWEBPUrl,
    analytics
  } = props.adBoxValues

  useEffect(() => {
    trackKaleyAdBoxEvents(analytics, 'Loaded')
  }, [])
  return (
    <Wrapper boxShadowSize='md' mx={2} width={['30%', null, null, null, '410px']} >
      <PromoBoxLink href={boxLink} onClick={() => trackKaleyAdBoxEvents(analytics, 'Clicked')}>
        <FlexWithTopBorder flexDirection={['column', null, null, null, 'row']} borderTopColor={borderTopColor}>
          <Hide xl xxl>
            <ImageOnTopWebP
              height='115px'
              image={tabletImageJPGUrl}
              imageWebP={tabletImageWEBPUrl}
            />
          </Hide>
          <TextWrapper flexDirection='column' p={3}>
            <Headline mt='-6px' fontSize={headline1FontSize} color={headline1Color || 'primary'} fontWeight='bold'>
              {headline1} <br />
              <Headline.span fontSize={headline2FontSize} color={headline2Color || 'text'} fontWeight='bold'>{headline2}</Headline.span>
            </Headline>
            <SubHeadLine fontSize={subHeadlineFontSize} color={subHeadlineColor} mt={2} style={{ lineHeight: '24px' }}>
              {subHeadline}
            </SubHeadLine>
            <Text fontSize={11} mt={[20, null, null, 'auto']}>
              {moreInfoText}
            </Text>
          </TextWrapper>
          <Hide xs sm md lg width={1}>
            <ImageOnRightWebP
              height='100%'
              image={desktopImageJPGUrl}
              imageWebP={desktopImageWEBPUrl}
            />
          </Hide>
        </FlexWithTopBorder>
      </PromoBoxLink>
    </Wrapper>
  )
}

KaleyPromoAdBox.propTypes = {
  adBoxValues: PropTypes.object,
  boxLink: PropTypes.string,
  headline1: PropTypes.string,
  headline1Color: PropTypes.string,
  headline2: PropTypes.string,
  headline2Color: PropTypes.string,
  subHeadline: PropTypes.string,
  subHeadlineFontSize: PropTypes.string,
  borderTopColor: PropTypes.string,
  desktopImageJPGUrl: PropTypes.string,
  desktopImageWEBPUrl: PropTypes.string,
  tabletImageJPGUrl: PropTypes.string,
  tabletImageWEBPUrl: PropTypes.string,
  moreInfoText: PropTypes.string
}

KaleyPromoAdBox.displayName = 'KaleyPromoAdBox'

export default KaleyPromoAdBox
